import { render } from "./VideoReferenceList.vue?vue&type=template&id=7269b6b2&scoped=true"
import script from "./VideoReferenceList.vue?vue&type=script&lang=js"
export * from "./VideoReferenceList.vue?vue&type=script&lang=js"

import "./VideoReferenceList.vue?vue&type=style&index=0&id=7269b6b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7269b6b2"

export default script